import Query from '../../Query.js';
import {
	OfflineTransactionHistory,
	StripeSubscriptionReturnFields,
} from '../returnFields';

/**
 * Get the stripe subscription object for an organization.
 *
 * @returns { Promise< { subscription: object } | { errors: string[] } >} res - { errors, subscription }
 */
const getVendorStripeSubscription = async function() {
	const { data, errors } = await this.request(
		new Query( {
			type: 'query',
			name: 'getStripeVendorSubscription',
			returnFields: StripeSubscriptionReturnFields,
		} )
	);

	if ( errors ) {
		return { errors };
	}

	const subscription = data.data.getStripeVendorSubscription;

	return { subscription };
};

/**
 * Requests a history of offline payments for a specific client user.
 *
 * @param { String } userID - the id of the base user for which to request a history
 * @param { Object } after - an object containing the ids to search after
 * @param { String } after.paymentAfter - the id of the paid installment to search after
 * @param { String } after.refundAfter - the id of the refunded installment to search after
 *
 * @returns { Promise< { offlineHistory: Array<object>, hasMore: boolean } | { errors: Array<string> } > }
 */
const getCustomerOfflineTransactionHistory = async function(
	clientUserID,
	after,
	limit = 10
) {
	const params = {
		where: { id: clientUserID },
		take: limit + 1,
	};
	if ( after ) params.after = after;

	const { errors, data } = await this.request(
		new Query( {
			type: 'query',
			params: params,
			name: 'getCustomerOfflineTransactionHistory',
			returnFields: OfflineTransactionHistory,
		} )
	);
	if ( errors ) {
		return { errors };
	}
	const offlineHistory =
		data.data.getCustomerOfflineTransactionHistory.offlinePaymentHistoryItems;
	let hasMore = false;
	if ( offlineHistory.length > limit ) {
		offlineHistory.pop();
		hasMore = true;
	}
	return {
		offlineHistory: offlineHistory,
		hasMore: hasMore,
	};
};

export { getVendorStripeSubscription, getCustomerOfflineTransactionHistory };
